import { GetMessages } from '@store/broadcast-messages/features/get-message/get-messages';
import { IBroadcastMessagesState } from '@store/broadcast-messages/types';
import { AxiosResponse } from 'axios';
import { IUpdateBroadcastMessageRequest } from 'lingopractices-models';
import { SagaIterator } from 'redux-saga';
import { call, put } from 'redux-saga/effects';

import { createDeferredAction } from '../../../common/actions';
import { httpRequestFactory } from '../../../common/http-request-factory';
import { HttpRequestMethod } from '../../../common/http-request-method';
import { MAIN_API } from '../../../common/path';

import { UpdateMessageFailure } from './update-message-failure';
import { UpdateMessageSuccess } from './update-message-success';

export class UpdateMessage {
  static get action() {
    return createDeferredAction<IUpdateBroadcastMessageRequest>('broadcastMessages/UPDATE_MESSAGE');
  }

  static get reducer() {
    return (draft: IBroadcastMessagesState) => {
      draft.requests.updateBroadcastMessagePending = true;
      return draft;
    };
  }

  static get saga() {
    return function* ({ payload, meta }: ReturnType<typeof UpdateMessage.action>): SagaIterator {
      try {
        UpdateMessage.httpRequest.call(
          yield call(() => UpdateMessage.httpRequest.generator(payload)),
        );

        yield put(UpdateMessageSuccess.action());
        yield put(GetMessages.action(null));

        meta?.deferred.resolve();
      } catch (e) {
        yield put(UpdateMessageFailure.action());
        meta?.deferred.reject(e);
      }
    };
  }

  static get httpRequest() {
    return httpRequestFactory<AxiosResponse<undefined>, IUpdateBroadcastMessageRequest>(
      MAIN_API.BROADCAST_MESSAGES,
      HttpRequestMethod.Put,
    );
  }
}
